import { HealthAnalysisService } from './../../module/health-analysis/health-analysis.service';
import { Injectable } from '@angular/core';
import { DeliveryServiceDescriptionModel } from './model/delivery-service-description.model';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DeliveryService {
    private serviceDescriptionList$ = new BehaviorSubject<Array<DeliveryServiceDescriptionModel>>([]);
    private segment = "ENCOMENDA"

    constructor(
        private healthAnalysisService: HealthAnalysisService
    ) {
        this.initialize();
    }


    initialize() {
        this.healthAnalysisService.getDeliveryServices(this.segment).subscribe(result => {
            this.serviceDescriptionList$.next(result);
        })
    }

    public getServiceDescriptionList(): Observable<Array<DeliveryServiceDescriptionModel>> {
        return this.serviceDescriptionList$;
    }
}
